/* Mi Bella Casa v1.3.0 */
(function () {
  'use strict';

  /* ---------- Rotadores (anuncios y banner) ---------- */
  function startRotator(root, items, dots, interval, key) {
    if (items.length < 2 || root.dataset[key]) return;
    root.dataset[key] = '1';
    var index = 0;
    var show = function (i) {
      index = i;
      items.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
      dots.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
    };
    root._mbcShow = show;
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); }); });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var timer = window.setInterval(function () {
      if (!root.isConnected) { window.clearInterval(timer); return; }
      if (root.dataset.paused === '1') return;
      show((index + 1) % items.length);
    }, Math.max(3000, Number(interval) || 5000));
  }

  function initRotators(scope) {
    (scope || document).querySelectorAll('[data-hero-slideshow]').forEach(function (el) {
      startRotator(el, Array.from(el.querySelectorAll('[data-hero-slide]')), Array.from(el.querySelectorAll('[data-hero-dot]')), el.dataset.interval, 'mbcInit');
    });
    (scope || document).querySelectorAll('[data-announcement-rotator]').forEach(function (el) {
      startRotator(el, Array.from(el.querySelectorAll('[data-announcement-message]')), [], el.dataset.interval, 'mbcInit');
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initRotators(document); });
  document.addEventListener('shopify:section:load', function (e) { initRotators(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-hero-slideshow],[data-announcement-rotator]');
    if (root) {
      root.dataset.paused = '1';
      var siblings = Array.from(root.querySelectorAll('[data-hero-slide],[data-announcement-message]'));
      var i = siblings.indexOf(e.target.closest('[data-hero-slide],[data-announcement-message]'));
      if (i > -1 && root._mbcShow) root._mbcShow(i);
    }
    var hotspot = e.target.closest('.scene-hotspot');
    if (hotspot) openHotspot(hotspot);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest('[data-hero-slideshow],[data-announcement-rotator]');
    if (root) root.dataset.paused = '';
  });

  /* ---------- Puntos interactivos ---------- */
  function closeHotspots(except) {
    document.querySelectorAll('.scene-hotspot.is-open').forEach(function (h) {
      if (h === except) return;
      h.classList.remove('is-open');
      var card = h.querySelector('.scene-hotspot__card');
      var dot = h.querySelector('[data-scene-dot]');
      if (card) card.hidden = true;
      if (dot) dot.setAttribute('aria-expanded', 'false');
    });
  }
  function openHotspot(h) {
    closeHotspots(h);
    h.classList.add('is-open');
    var card = h.querySelector('.scene-hotspot__card');
    var dot = h.querySelector('[data-scene-dot]');
    if (card) card.hidden = false;
    if (dot) dot.setAttribute('aria-expanded', 'true');
  }

  /* ---------- Categorías: flechas del slider ---------- */
  function updateSlider(track) {
    var wrap = track.closest('[data-category-section]');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-slider-prev]');
    var next = wrap.querySelector('[data-slider-next]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    var bar = wrap.querySelector('[data-slider-progress]');
    if (bar) {
      var thumb = bar.firstElementChild;
      var visible = Math.min(1, track.clientWidth / track.scrollWidth);
      bar.hidden = visible >= 0.999;
      thumb.style.width = (visible * 100) + '%';
      thumb.style.left = ((track.scrollLeft / track.scrollWidth) * 100) + '%';
    }
  }
  function initSliders(scope) {
    (scope || document).querySelectorAll('[data-slider-track]').forEach(function (track) {
      if (track.dataset.mbcInit) return;
      track.dataset.mbcInit = '1';
      track.addEventListener('scroll', function () { updateSlider(track); }, { passive: true });
      updateSlider(track);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initSliders(document); });
  window.addEventListener('resize', function () { document.querySelectorAll('[data-slider-track]').forEach(updateSlider); });
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });

  /* ---------- Clics (delegación) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var arrow = t.closest('[data-slider-prev],[data-slider-next]');
    if (arrow) {
      var trk = arrow.closest('[data-category-section]').querySelector('[data-slider-track]');
      if (trk) trk.scrollBy({ left: (arrow.hasAttribute('data-slider-next') ? 1 : -1) * trk.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }

    var dot = t.closest('[data-scene-dot]');
    if (dot) {
      var h = dot.closest('.scene-hotspot');
      if (h.classList.contains('is-open')) closeHotspots(); else openHotspot(h);
      return;
    }
    if (!t.closest('.scene-hotspot')) closeHotspots();

    var filter = t.closest('[data-scene-filter]');
    if (filter) {
      var section = filter.closest('[data-scenes-section]');
      var value = filter.getAttribute('data-scene-filter');
      section.querySelectorAll('[data-scene-filter]').forEach(function (b) { b.classList.toggle('is-active', b === filter); });
      section.querySelectorAll('[data-scene-product]').forEach(function (item) {
        var cat = item.getAttribute('data-category') || '';
        item.style.display = (value === 'all' || cat === value) ? '' : 'none';
      });
      closeHotspots();
      return;
    }

    var wa = t.closest('[data-whatsapp-quote]');
    if (wa) {
      var number = (wa.dataset.whatsappNumber || '').replace(/\D/g, '');
      if (!number || number.length < 10) {
        alert('Configura el número de WhatsApp en la configuración del tema antes de usar este botón.');
        return;
      }
      var title = wa.dataset.productTitle || document.title;
      var url = wa.dataset.productUrl || window.location.href;
      var qtyInput = document.querySelector('.product-form [name="quantity"]');
      var qty = qtyInput ? qtyInput.value : '1';
      var vs = document.querySelector('[data-product-variant]');
      var variant = vs ? vs.options[vs.selectedIndex].text.split(' — ')[0] : '';
      var msg;
      if (wa.dataset.whatsappIntent === 'availability') {
        msg = 'Hola, quiero consultar la disponibilidad en sucursal de este producto: ' + title + (variant ? '\nVariante: ' + variant : '') + '\n¿En qué sucursal lo tienen disponible?\nProducto: ' + url;
      } else {
        msg = 'Hola, quiero cotizar para mayoreo este producto: ' + title + '\nCantidad aproximada: ' + qty + ' pieza(s)' + (variant ? '\nVariante: ' + variant : '') + '\n¿Me pueden compartir precio por volumen y costo de envío?\nProducto: ' + url;
      }
      window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
      return;
    }

    var minus = t.closest('[data-qty-minus]');
    var plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      var input = (minus || plus).parentElement.querySelector('input');
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v + (plus ? 1 : -1));
      return;
    }

    var thumb = t.closest('[data-product-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-product-gallery]');
      var main = gallery.querySelector('.product-gallery__main-image');
      if (main) {
        main.src = thumb.dataset.fullImage;
        main.srcset = '';
        main.alt = thumb.dataset.alt || '';
      }
      gallery.querySelectorAll('[data-product-thumb]').forEach(function (i) { i.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    var menu = t.closest('[data-mobile-menu]');
    if (menu) {
      var nav = document.querySelector('[data-header-nav]');
      if (!nav) return;
      menu.setAttribute('aria-expanded', String(nav.classList.toggle('is-open')));
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeHotspots(); });

  /* ---------- Cambio de variante ---------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-product-variant]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var ok = option.dataset.available === 'true';

    var price = document.querySelector('[data-product-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;

    var cmp = document.querySelector('[data-product-compare]');
    if (cmp) {
      cmp.hidden = option.dataset.hasCompare !== 'true';
      var cv = cmp.querySelector('[data-product-compare-value]');
      if (cv) cv.textContent = option.dataset.compare;
    }

    var addButton = document.querySelector('[data-add-to-cart]');
    if (addButton) {
      addButton.disabled = !ok;
      var label = addButton.querySelector('[data-add-label]');
      if (label) label.textContent = ok ? 'Agregar al carrito' : 'Agotado';
    }

    var stock = document.querySelector('[data-product-stock]');
    if (stock) {
      stock.classList.toggle('is-unavailable', !ok);
      stock.innerHTML = ok ? '<span>✓</span> Disponible para compra' : 'Producto agotado temporalmente';
    }

    document.querySelectorAll('[data-store-availability]').forEach(function (el) {
      el.hidden = el.dataset.variant !== option.value;
    });

    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', u.toString());
    } catch (err) {}

    var hidden = document.querySelector('[data-variant-id]');
    if (hidden) hidden.value = option.value;
  });
})();
